export default "__VITE_ASSET__DK6Vdy86__"